module.exports = __webpack_public_path__ + "img/referto-1.9715c7d3.jpg";